import { useQueryHandler } from "@sinch/hooks/useQueryHandler";
import { mapToOptions, Option } from "@sinch/utils/option";
import { RequirementsData } from "@sinch/views/ShiftTimeline/StaffFilter/queries.graphql";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { RequirementsDataQuery } from "@sinch/components/application/Requirements/queries.types";
import { AutocompleteInput } from "@sinch/components/form/AutocompleteInput/AutocompleteInput";
import { AutocompleteInputProps, AutocompleteOptions } from "@sinch/components/form/AutocompleteInput/types";

type RequirementSelectProps<T extends AutocompleteOptions = AutocompleteOptions> = Omit<
  AutocompleteInputProps<T, false, true, false>,
  "disableClearable" | "inputReadOnly" | "options" | "multiple" | "freeSolo" | "ref"
>;

export const RequirementCategoryInput = <T extends AutocompleteOptions = AutocompleteOptions>(
  props: RequirementSelectProps<T>
) => {
  const { t } = useTranslation();

  const { data } = useQueryHandler<RequirementsDataQuery>(RequirementsData);
  const requirements = data?.requirements;

  const requirementOptions: Option[] = useMemo(() => mapToOptions("id", "label")(requirements || []), [requirements]);

  return (
    <AutocompleteInput
      disablePortal={false}
      label={t("Requirement.requirement")}
      placeholder={t("Requirement.enterRequirement")}
      size="small"
      {...props}
      disableClearable
      freeSolo={false}
      inputReadOnly
      multiple={false}
      options={requirementOptions}
    />
  );
};
